export const Role = [
    "super",
    "admin",
    "user",
    "approver",
    "finance",
    "traffic_super",
    "traffic_admin"
]